var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9439e8",
    d: "m22.445 7.61-1.2 8.58c-.26 1.8-1.25 2.75-2.88 2.75-.13 0-.26-.01-.4-.02a3.73 3.73 0 0 0 .04-.59V9.66A2.357 2.357 0 0 0 15.335 7h-9.97c0-.02.01-.05.01-.07l.24-1.68a3.242 3.242 0 0 1 1.13-2.23A3.26 3.26 0 0 1 9.2 2.55l10.56 1.48a3.247 3.247 0 0 1 2.22 1.14 3.148 3.148 0 0 1 .465 2.44z",
    opacity: 1,
    "data-original": "#396ce8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8339e8",
    d: "M2 18.333V9.665A2.357 2.357 0 0 1 4.667 7h10.668A2.358 2.358 0 0 1 18 9.665v8.668A2.358 2.358 0 0 1 15.335 21H4.667A2.357 2.357 0 0 1 2 18.333z",
    opacity: 0.25098039215686274,
    "data-original": "#396ce840",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9439e8",
    d: "M12.5 13.25h-1.75V11.5a.75.75 0 0 0-1.5 0v1.75H7.5a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75h1.75a.75.75 0 0 0 0-1.5z",
    opacity: 1,
    "data-original": "#396ce8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageGallery);
export default __webpack_public_path__ + "static/media/image-gallery.e5faf7b7f218a64872ba6c895ce67d74.svg";
export { ForwardRef as ReactComponent };